const PRODUCTS = [
  {
    id: 'vpn',
    name: 'NOX VPN',
    tagline: 'Privacy & Security',
    description:
      'A powerful VPN solution built natively for iOS. NOX VPN encrypts your internet connection and shields your digital identity — whether you\'re on public Wi-Fi or traveling abroad. Engineered with military-grade protocols and a strict no-log policy, it ensures your data stays exclusively yours.',
    highlights: ['Military-grade AES-256 encryption', 'No-log privacy policy', 'Global server network', 'Kill switch protection'],
    icon: 'ri-shield-keyhole-line',
    color: 'from-emerald-500 to-teal-600',
    image:
      'https://public.readdy.ai/ai/img_res/c597183b75da8e1f38408ffe1fa93fb0.jpg',
  },
  {
    id: 'cleaner',
    name: 'NOX Cleaner',
    tagline: 'Performance Optimizer',
    description:
      'Reclaim your iPhone\'s full potential with NOX Cleaner. This intelligent optimization tool scans, detects, and eliminates junk files, duplicate content, and unnecessary data that slow down your device. Experience a faster, more responsive iPhone — every single day.',
    highlights: ['Smart junk file detection', 'Duplicate photo removal', 'Storage space recovery', 'Real-time performance insights'],
    icon: 'ri-sparkling-2-line',
    color: 'from-amber-500 to-orange-500',
    image:
      'https://readdy.ai/api/search-image?query=sleek%20modern%20smartphone%20with%20sparkling%20clean%20minimalist%20interface%20on%20screen%2C%20light%20cream%20and%20warm%20background%2C%20iOS%20cleaner%20optimizer%20app%20concept%2C%20professional%20minimal%20product%20photography%2C%20clean%20bright%20white%20background%20with%20subtle%20warm%20amber%20gradient%20glow%2C%20fresh%20organized%20aesthetic%20high%20end%20tech&width=600&height=700&seq=cleaner001&orientation=portrait',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="w-full bg-white py-24 md:py-36 px-6 md:px-16">
      {/* Header */}
      <div className="text-center mb-16 md:mb-24">
        <span className="text-emerald-500 text-xs font-semibold tracking-[0.2em] uppercase">What We Build</span>
        <h2 className="mt-3 text-3xl md:text-5xl font-bold text-[#1C1C1E] tracking-tight">Our Products</h2>
        <p className="mt-4 text-[#8E8E93] text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          Two focused applications, built with precision — each designed to solve a specific challenge faced by every iOS user.
        </p>
        <div className="mt-6 w-14 h-0.5 bg-emerald-500 mx-auto rounded-full" />
      </div>

      {/* Product Cards */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12">
        {PRODUCTS.map((product) => (
          <div
            key={product.id}
            className="group rounded-2xl overflow-hidden bg-[#F9F9F9] hover:bg-[#F2F2F2] transition-all duration-300"
          >
            {/* Product Image */}
            <div className="relative w-full h-[280px] md:h-[340px] overflow-hidden">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              <div className={`absolute top-5 left-5 w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br ${product.color}`}>
                <i className={`${product.icon} text-white text-xl`} />
              </div>
            </div>

            {/* Product Info */}
            <div className="p-8 md:p-10">
              <span className="text-xs font-semibold tracking-widest uppercase text-emerald-500">{product.tagline}</span>
              <h3 className="mt-2 text-2xl md:text-3xl font-bold text-[#1C1C1E]">{product.name}</h3>
              <p className="mt-4 text-[#6C6C70] text-sm md:text-base leading-relaxed">{product.description}</p>

              {/* Highlights */}
              <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                {product.highlights.map((item) => (
                  <li key={item} className="flex items-center gap-2 text-sm text-[#3A3A3C]">
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                      <i className="ri-checkbox-circle-fill text-emerald-500" />
                    </div>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
